<template>
    <div @mouseover="checkAnimation" class="event-booker-container">
        <div class="event-schedule">
            <div class="event-date">Sat, July 24th</div>
            <div class="event-time">8:00PM-12:00AM</div>
        </div>
        <transition name="title" mode="out-in">
            <div v-if="showPhaseOne || showPhaseTwo" key="title-one" class="event-title">
                Add an Event Title...
            </div>
            <div v-else key="title-two" class="event-title">
                Lazy Saturdays with Cannon Wit
            </div>
        </transition>
        <div class="event-info">
            <transition name="budget-info" mode="out-in">
                <transition-group
                    name="budget-text"
                    tag="div"
                    v-if="showBudget"
                    key="budget-info"
                    class="event-budget"
                >
                    <div
                        v-for="budget in renderBudgetInfo"
                        :key="budget.id"
                        class="budget-info"
                    >
                        {{ budget.text }}
                    </div>
                </transition-group>
                <div v-else class="event-budget" key="payout-info">
                    <div class="budget-info">
                        {{ payoutInfo.text }}
                    </div>
                </div>
            </transition>
            <div class="event-tags" v-if="!isMobile">
                <div v-for="(tag, indx) in eventTags" :key="indx" class="tag">
                    {{ tag }}
                </div>
            </div>
        </div>
        <transition name="artists" mode="out-in">
            <div v-if="showArtists" class="event-artists">
                <div :class="artistSummaryClass">
                    {{ artistSummary }}
                </div>
                <div class="artists">
                    <div
                        v-for="artist in renderArtists"
                        :key="artist.name"
                        :class="artistClass"
                    >
                        <img :src="artist.src" />
                        <div class="artist-name" v-if="!isMobile">
                            {{ artist.name }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="card-divider">&nbsp;</div>
        <transition-group
            v-show="!isMobile"
            name="booking-progress"
            tag="div"
            class="booking-progress"
        >
            <div
                v-for="progress in progressIndicators"
                :key="progress.id"
                class="progress-indicator"
            >
                <transition name="progress" mode="out-in">
                    <div v-if="progress.arrow" :key="arrowKey" class="progress-arrow">
                        <img :src="renderArrow(progress)" />
                    </div>
                    <div
                        v-else-if="progress.past"
                        :key="`progress-${progress.id}-past`"
                        :ref="`progress-${progress.id}`"
                        class="past-progress"
                    >
                        {{ progress.pastText }}
                    </div>
                    <div
                        v-else
                        :key="`progress-${progress.id}-future`"
                        :ref="`progress-${progress.id}`"
                        :style="progressBackground(progress)"
                        class="future-progress"
                    >
                        {{ progress.text }}
                    </div>
                </transition>
            </div>
        </transition-group>
        <transition-group
            v-show="isMobile"
            name="booking-progress-mobile"
            class="booking-progress"
        >
            <div
                v-for="progress in mobileProgressIndicators"
                :key="progress.id"
                class="progress-indicator"
            >
                <transition name="progress-mobile" mode="out-in">
                    <div v-if="progress.arrow" :key="arrowKey" class="progress-arrow">
                        <img :src="renderArrow(progress)" />
                    </div>
                    <div
                        v-else
                        :key="`progress-${progress.id}-future`"
                        :ref="`progress-${progress.id}`"
                        :style="mobileProgressStyles(progress)"
                        class="future-progress"
                    >
                        {{ progress.texts[currentAnimation] }}
                    </div>
                </transition>
            </div>
        </transition-group>
    </div>
</template>
<script>
    import checkScreen from '../../../mixins/check-screen'

    const ANIMATION_LABELS = {
        'check-avails': 0,
        'book-artists': 1,
        'advance-step': 2,
        'wrapup-step': 3
    }
    export default {
        name: 'EventVenue',
        mixins: [checkScreen],
        props: {
            animate: {
                required: true,
                type: Boolean
            }
        },
        data: () => ({
            animating: false,
            animationTimeout: null,
            resetTimeout: null,
            resetTimer: 3000,
            mobileProgressIndicators: [
                {
                    id: 0,
                    arrow: {
                        green: '/images/arrow-event-check-avails.png',
                        yellow: '/images/arrow-event-booking.png',
                        orange: '/images/event-advance-arrow.png',
                        red: '/images/wrap-up-arrow.png'
                    }
                },
                {
                    id: 1,
                    texts: ['Check Avails', 'Book Artist', 'Advance', 'Advanced'],
                    backgrounds: ['#c9eb09', '#c9cd00', '#cb9b1f', 'transparent'],
                    colors: ['#262626', '#262626', '#262626', '#8b8b8b']
                },
                {
                    id: 2,
                    texts: ['Book Artists', 'Advance', 'Wrap Up', 'Wrap Up'],
                    backgrounds: [null, null, null, '#d188bf'],
                    colors: ['#8b8b8b', '#8b8b8b', '#8b8b8b', '#262626']
                }
            ],
            progressIndicators: [
                {
                    id: 0,
                    arrow: {
                        green: '/images/arrow-event-check-avails.png',
                        yellow: '/images/arrow-event-booking.png',
                        orange: '/images/event-advance-arrow.png',
                        red: '/images/wrap-up-arrow.png'
                    },
                    past: false,
                    text: null,
                    pastText: null,
                    background: null
                },
                {
                    id: 1,
                    arrow: null,
                    past: false,
                    text: 'Check Avails',
                    pastText: 'Avails Checked',
                    background: '#CDEB09'
                },
                {
                    id: 2,
                    arrow: null,
                    past: false,
                    text: 'Book Artists',
                    pastText: 'Artists Booked',
                    background: null
                },
                {
                    id: 3,
                    arrow: null,
                    past: false,
                    text: 'Advance',
                    pastText: 'Advanced',
                    background: null
                },
                {
                    id: 4,
                    arrow: null,
                    past: false,
                    text: 'Wrap Up',
                    pastText: 'Wrap Up',
                    background: null
                }
            ],
            eventTags: ['Event Tag', 'Event Tag', 'Event Tag'],

            renderBudgetInfo: [],
            budgetInfo: [
                {
                    id: ANIMATION_LABELS['check-avails'],
                    text: 'Budget $600'
                },
                {
                    id: ANIMATION_LABELS['advance-step'],
                    text: 'Est. Payout: $550'
                }
            ],

            payoutInfo: {
                id: ANIMATION_LABELS['wrapup-step'],
                text: 'Scheduled Payout: $550'
            },

            artistInfo: [
                {
                    phases: ['two', 'three', 'four'],
                    name: 'Cannon Wit',
                    src: '/images/icons/message-flow/maxine.svg'
                },
                {
                    phases: ['two'],
                    name: 'Aubrey Watts',
                    src: '/images/icons/message-flow/pixel.svg'
                },
                {
                    phases: ['two', 'three', 'four'],
                    name: 'Mikey Palmice',
                    src: '/images/icons/message-flow/dreambot.svg'
                },
                {
                    phases: ['two'],
                    name: 'Pixel Rainbow',
                    src: '/images/icons/message-flow/pixel.svg'
                }
            ],

            currentAnimation: 0,
            animations: [
                {
                    id: ANIMATION_LABELS['check-avails'],
                    phase: 'one',
                    refs: [
                        {
                            ref: 'progress-1',
                            class: ['progress-phase-one']
                        }
                    ],
                    timeout: 1500
                },
                {
                    id: ANIMATION_LABELS['book-artists'],
                    phase: 'two',
                    refs: [
                        {
                            ref: 'progress-2',
                            class: ['progress-phase-two']
                        }
                    ],
                    timeout: 1500
                },
                {
                    id: ANIMATION_LABELS['advance-step'],
                    phase: 'three',
                    refs: [
                        {
                            ref: 'progress-3',
                            class: ['progress-phase-three']
                        }
                    ],
                    timeout: 1500
                },
                {
                    id: ANIMATION_LABELS['wrapup-step'],
                    phase: 'four',
                    refs: [
                        {
                            ref: 'progress-4',
                            class: ['progress-phase-four']
                        }
                    ],
                    timeout: 1500
                }
            ]
        }),

        methods: {
            startAnimations() {
                if (!this.animating) this.animating = true

                let animation = this.animations.find((a) => a.id === this.currentAnimation)

                if (animation.refs) {
                    this.animateEl(animation)
                }
                this.handleAnimations(animation)
            },

            checkAnimation() {
                this.resetTimeout = setTimeout(() => {
                    if (!this.animating) {
                        this.startAnimations()
                    }
                }, this.resetTimer)
            },

            handleAnimations(animation) {
                this.animationTimeout = setTimeout(() => {
                    if (this.currentAnimation === this.animations.length - 1) {
                        this.resetAnimations()
                    } else {
                        this.currentAnimation = this.currentAnimation + 1
                        this.startAnimations()
                    }
                }, animation.timeout)
            },

            animateEl(animation) {
                for (let i = 0; i < animation.refs.length; i++) {
                    if (!this.$refs[animation.refs[i].ref]) continue

                    let classList = this.$refs[animation.refs[i].ref][0].classList

                    for (let j = 0; j < animation.refs[i].class.length; j++) {
                        if (!this.isMobile) {
                            this.removeOtherAnimations(animation)
                            classList.add(animation.refs[i].class[j])
                        }
                    }
                }
            },

            resetAnimations() {
                this.resetTimeout = setTimeout(() => {
                    this.currentAnimation = 0
                    this.animating = false
                    this.removeAnimations()
                }, this.resetTimer)
            },

            removeAnimations() {
                for (let a = 0; a < this.animations.length; a++) {
                    let animation = this.animations[a]

                    if (!animation.refs) continue

                    for (let i = 0; i < animation.refs.length; i++) {
                        if (!this.$refs[animation.refs[i].ref]) continue
                        let classList = this.$refs[animation.refs[i].ref][0].classList

                        for (let j = 0; j < animation.refs[i].class.length; j++) {
                            classList.remove(animation.refs[i].class[j])
                        }
                    }
                }
            },

            removeOtherAnimations(animationEl) {
                for (let a = 0; a < this.animations.length; a++) {
                    let animation = this.animations[a]

                    if (animation.id === animationEl.id) continue
                    if (!animation.refs) continue

                    for (let i = 0; i < animation.refs.length; i++) {
                        if (!this.$refs[animation.refs[i].ref]) continue
                        let classList = this.$refs[animation.refs[i].ref][0].classList

                        for (let j = 0; j < animation.refs[i].class.length; j++) {
                            classList.remove(animation.refs[i].class[j])
                        }
                    }
                }
            },

            getBudgetIndex(label) {
                return this.budgetInfo.indexOf(this.budgetInfo.find((b) => b.id === label))
            },

            resetBudgetInfo() {
                this.renderBudgetInfo.splice(0)
                this.renderBudgetInfo.push(
                    this.budgetInfo[this.getBudgetIndex(ANIMATION_LABELS['check-avails'])]
                )
            },

            moveProgress(fromIndx, toIndx) {
                if (!this.isMobile) {
                    let currentProgress = this.progressIndicators[fromIndx]

                    this.progressIndicators.splice(fromIndx, 1)
                    this.progressIndicators.splice(toIndx, 0, currentProgress)
                } else {
                    let currentProgress = this.mobileProgressIndicators[fromIndx]

                    this.mobileProgressIndicators.splice(fromIndx, 1)
                    this.mobileProgressIndicators.splice(toIndx, 0, currentProgress)
                }
            },

            markPastProgress(indx) {
                let pastProgresses = this.progressIndicators.filter((p) => p.id <= indx)
                pastProgresses.forEach((p) => (p.past = true))
            },

            resetProgress() {
                this.progressIndicators.forEach((p) => (p.past = false))
            },

            manageAnimationSideEffects(index) {
                switch (index) {
                    case this.ANIMATION_LABELS['check-avails']:
                        this.resetProgress()
                        this.resetBudgetInfo()
                        this.moveProgress(
                            this.ANIMATION_LABELS['wrapup-step'],
                            this.ANIMATION_LABELS['check-avails']
                        )
                        break

                    case this.ANIMATION_LABELS['book-artists']:
                        this.markPastProgress(index)
                        this.moveProgress(
                            this.ANIMATION_LABELS['check-avails'],
                            this.ANIMATION_LABELS['book-artists']
                        )
                        break

                    case this.ANIMATION_LABELS['advance-step']:
                        this.markPastProgress(index)
                        this.renderBudgetInfo.push(
                            this.budgetInfo[
                                this.getBudgetIndex(ANIMATION_LABELS['advance-step'])
                            ]
                        )
                        this.moveProgress(
                            this.ANIMATION_LABELS['book-artists'],
                            this.ANIMATION_LABELS['advance-step']
                        )
                        break

                    case this.ANIMATION_LABELS['wrapup-step']:
                        this.markPastProgress(index)
                        this.moveProgress(
                            this.ANIMATION_LABELS['advance-step'],
                            this.ANIMATION_LABELS['wrapup-step']
                        )
                        break

                    default:
                        return
                }
            },

            manageMobileAnimationSideEffects(index) {
                switch (index) {
                    case this.ANIMATION_LABELS['check-avails']:
                        this.resetProgress()
                        this.resetBudgetInfo()
                        this.moveProgress(1, 0)
                        break
                    case this.ANIMATION_LABELS['book-artists']:
                        break

                    case this.ANIMATION_LABELS['advance-step']:
                        this.renderBudgetInfo.push(
                            this.budgetInfo[
                                this.getBudgetIndex(ANIMATION_LABELS['advance-step'])
                            ]
                        )
                        break

                    case this.ANIMATION_LABELS['wrapup-step']:
                        this.markPastProgress(index)
                        this.moveProgress(0, 1)
                        break

                    default:
                        return
                }
            }
        },

        computed: {
            isMobile: (self) => self.width < 600,

            ANIMATION_LABELS: () => ANIMATION_LABELS,

            showPhaseOne: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'one',

            showPhaseTwo: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'two',

            showPhaseThree: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'three',

            showPhaseFour: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'four',

            showArtists: (self) =>
                self.showPhaseTwo || self.showPhaseThree || self.showPhaseFour,

            showBudget: (self) =>
                self.showPhaseOne || self.showPhaseTwo || self.showPhaseThree,

            renderArtists: (self) => {
                if (self.showPhaseTwo) {
                    return self.artistInfo.filter((a) => a.phases.includes('two'))
                } else if (self.showPhaseThree) {
                    return self.artistInfo.filter((a) => a.phases.includes('three'))
                } else if (self.showPhaseFour) {
                    return self.artistInfo.filter((a) => a.phases.includes('four'))
                }
            },

            artistClass: (self) => {
                let _class = { artist: true }

                if (self.showPhaseTwo) {
                    _class['artist-yellow'] = true
                } else if (self.showPhaseThree) {
                    _class['artist-orange'] = true
                } else if (self.showPhaseFour) {
                    _class['artist-red'] = true
                }

                return _class
            },

            artistSummary: (self) => {
                if (self.showPhaseTwo) {
                    return '6 artists have applied:'
                } else if (self.showPhaseThree || self.showPhaseFour) {
                    return '2 artists booked:'
                }
            },

            artistSummaryClass: (self) => {
                let _class = { 'artist-summary': true }

                if (self.showPhaseTwo) {
                    _class['summary-yellow'] = true
                } else if (self.showPhaseThree) {
                    _class['summary-orange'] = true
                } else if (self.showPhaseFour) {
                    _class['summary-red'] = true
                }

                return _class
            },

            progressBackground: () => (progress) => {
                if (progress.background) {
                    return {
                        background: progress.background,
                        color: '#8b8b8b'
                    }
                } else {
                    return {}
                }
            },

            mobileProgressStyles: (self) => (progress) => ({
                background: progress.backgrounds[self.currentAnimation]
                    ? progress.backgrounds[self.currentAnimation]
                    : '',
                color: progress.colors[self.currentAnimation]
                    ? progress.colors[self.currentAnimation]
                    : ''
            }),

            arrowKey: (self) => {
                if (self.showPhaseOne) {
                    return 'phase-one-arrow'
                } else if (self.showPhaseTwo) {
                    return 'phase-two-arrow'
                } else if (self.showPhaseThree) {
                    return 'phase-three-arrow'
                } else if (self.showPhaseFour) {
                    return 'phase-four-arrow'
                }
            },

            renderArrow: (self) => (progress) => {
                if (self.showPhaseOne) {
                    return progress.arrow.green
                } else if (self.showPhaseTwo) {
                    return progress.arrow.yellow
                } else if (self.showPhaseThree) {
                    return progress.arrow.orange
                } else if (self.showPhaseFour) {
                    return progress.arrow.red
                }
            }
        },

        watch: {
            currentAnimation: function (index) {
                if (!this.isMobile) {
                    this.manageAnimationSideEffects(index)
                } else {
                    this.manageMobileAnimationSideEffects(index)
                }
            }
        },
        created() {
            this.resetBudgetInfo()
        }
    }
</script>
<style lang="scss" scoped>
    @media (max-width: 600px) {
        .event-booker-container {
            padding: 16px !important;
            width: 353px !important;

            .event-artists {
                .artists {
                    .artist {
                        min-width: min-content !important;
                        padding: 5px 5px 5px 5px !important;
                    }
                }
            }
        }
        .event-booker-container {
            .event-title {
                font-size: 20px !important;
            }
            .event-schedule {
                .event-date {
                    font-size: 20px !important;
                }
            }
        }
        .discover-artist {
            padding-right: 0;
        }
    }
    .booking-progress-move {
        transition: transform 0.5s;
    }
    .booking-progress-mobile-move {
        transition: transform 0.5s;
    }

    .title-enter,
    .title-leave-to {
        opacity: 0;
    }
    .title-enter-active,
    .title-leave-active {
        transition: opacity 0.5s;
    }

    .budget-info-enter,
    .budget-info-leave-to {
        opacity: 0;
    }
    .budget-info-enter-active,
    .budget-info-leave-active {
        transition: opacity 0.5s;
    }

    .budget-text-enter {
        opacity: 0;
        transform: translateX(-50px);
    }
    .budget-list-leave-to {
        opacity: 0;
    }
    .budget-text-enter-active,
    .budget-text-leave-active {
        transition: all 0.5s;
    }

    .artists-enter,
    .artists-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
    .artists-enter-active,
    .artists-leave-active {
        transition: all 0.5s;
    }

    .event-booker-container {
        background: #262626;
        max-width: 640px;
        width: 100%;
        height: fit-content;
        border-radius: 15px;
        padding: 20px 25px 25px 25px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .event-schedule {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: baseline;
            gap: 15px;

            .event-date {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 32px;
                font-style: normal;
                font-weight: 500;
                line-height: 120%;
                letter-spacing: -0.64px;
            }

            .event-time {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }

        .event-title {
            margin-top: 7px;
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 22px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.22px;
        }

        .event-info {
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;

            .event-budget {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                gap: 6px;

                .budget-info {
                    color: #8b8b8b;
                    text-align: justify;
                    text-wrap: nowrap;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
            }

            .event-tags {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                gap: 6px;

                .tag {
                    padding: 3px 10px 4px 10px;
                    border: 1px solid #646464;
                    border-radius: 100px;
                    color: #646464;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
            }
        }

        .event-artists {
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            align-items: flex-start;

            .artist-summary {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 130%; /* 18.2px */
                letter-spacing: 0.14px;
            }

            .summary-yellow {
                color: #c9cd00;
            }

            .summary-orange {
                color: #cb9b1f;
            }

            .summary-red {
                color: #d188bf;
            }

            .artists {
                margin-top: 10px;
                max-width: 590px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                gap: 10px;
                overflow: hidden;

                .artist {
                    display: flex;
                    padding: 5px 12px 5px 5px;
                    min-width: 150px;
                    align-items: center;
                    gap: 10px;
                    border-radius: 100px;
                    border: 1px solid #cdeb09;
                    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
                        0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                    margin-right: 8px;

                    img {
                        width: 20px;
                        height: 20px;
                        object-fit: cover;
                        border-radius: 50%;
                    }

                    .artist-name {
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%; /* 18.2px */
                        letter-spacing: 0.14px;
                    }
                }

                .artist-yellow {
                    border: 1px solid #c9cd00;

                    .artist-name {
                        color: #c9cd00;
                    }
                }

                .artist-orange {
                    border: 1px solid #cb9b1f;

                    .artist-name {
                        color: #cb9b1f;
                    }
                }

                .artist-red {
                    border: 1px solid #d188bf;

                    .artist-name {
                        color: #d188bf;
                    }
                }
            }
        }

        .card-divider {
            height: 1px;
            width: 100%;
            background: #646464;
            margin-top: 25px;
            margin-bottom: 25px;
        }

        .booking-progress {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: 8px;
            width: 100%;

            .progress-indicator {
                .past-progress,
                .future-progress {
                    min-width: 120px;
                    text-align: center;
                    background: #262626;
                    padding: 10px 25px 10px 25px;
                    border-radius: 100px;
                    border: 1px solid #8b8b8b;
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    text-wrap: nowrap;
                }

                .progress-phase-one {
                    background: #cdeb09;
                    color: #262626 !important;
                }
                .progress-phase-two {
                    background: #c9cd00 !important;
                    color: #262626;
                }
                .progress-phase-three {
                    background: #cb9b1f;
                    color: #262626;
                }
                .progress-phase-four {
                    background: #d188bf;
                    color: #262626;
                }
            }
        }
    }
</style>
